import { cloneDeep } from 'lodash'

import { Services, joinURLPath, storageFileIsDownloadBlocked } from '@sigma-frontend-libs/commons'

import { getStorageURL, globalErrorHandler, permissionPresets, request } from '@/utils'

import render from './render'

export default {
  name: 'FileMenu',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    readonly: Boolean,

    include: {
      type: Array,
      default: () => {
        return [ 'edit', 'update', 'download', 'export', 'remove' ]
      }
    }
  },

  data() {
    return {
      loading: false
    }
  },

  computed: {
    editable() {
      return (
        this.checkPermissions([ `advanced.${Services.storage}.update`, `advanced.${Services.storage}.remove` ], permissionPresets.meUp) &&
        !this.readonly
      )
    },

    isDownloadBlocked() {
      return storageFileIsDownloadBlocked(this.value)
    }
  },

  methods: {
    async editFile() {
      this.loading = true

      try {
        const data = await request.get(
          joinURLPath(Services.storage, 'edit', this.value.id),
          undefined,
          {
            OwnerId: this.value.OwnerId || this.value.Owner && this.value.Owner.id
          }
        )
        if (data) {
          this.$emit('dialog', {
            googleFileURL: data.result,
            currentEditFile: cloneDeep(this.value),
            editDialogType: 'edit'
          })
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    },

    removeFile() {
      this.$emit('dialog', {
        currentEditFile: cloneDeep(this.value),
        editDialogType: 'remove'
      })
    },

    async exportFile() {
      if (this.isDownloadBlocked) {
        return
      }

      this.$emit('dialog', {
        currentEditFile: cloneDeep(this.value),
        editDialogType: 'export'
      })

      try {
        const data = await request.get(joinURLPath(Services.storage, 'export', this.value.id))
        window.location.href = getStorageURL([ data.OwnerId, data.id ])
      } catch (error) {
        globalErrorHandler(error)
      }

      this.$emit('dialog', { close: true })
    },

    downloadFile() {
      if (this.isDownloadBlocked) {
        return
      }

      window.location.href = getStorageURL([ this.value.OwnerId || this.value.Owner && this.value.Owner.id, this.value.id ])
    },

    editMetaFile() {
      this.$emit('dialog', {
        currentEditFile: cloneDeep(this.value),
        editDialogType: 'editMeta'
      })
    }
  },

  render
}
